import { render, staticRenderFns } from "./ListIcon.vue?vue&type=template&id=6a97ef2c&scoped=true&"
import script from "./ListIcon.vue?vue&type=script&lang=js&"
export * from "./ListIcon.vue?vue&type=script&lang=js&"
import style0 from "./ListIcon.vue?vue&type=style&index=0&id=6a97ef2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a97ef2c",
  null
  
)

component.options.__file = "ListIcon.vue"
export default component.exports